<svg
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M14 14L11.1667 11.1617M12.7368 7.36842C12.7368 8.79221 12.1712 10.1577 11.1645 11.1645C10.1577 12.1712 8.79221 12.7368 7.36842 12.7368C5.94463 12.7368 4.57915 12.1712 3.57237 11.1645C2.5656 10.1577 2 8.79221 2 7.36842C2 5.94463 2.5656 4.57915 3.57237 3.57237C4.57915 2.5656 5.94463 2 7.36842 2C8.79221 2 10.1577 2.5656 11.1645 3.57237C12.1712 4.57915 12.7368 5.94463 12.7368 7.36842Z"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
</svg>
